// TransactionTransferTable.tsx
import React from "react";
import moment from "moment";
import { numberWithCommas } from "../../../utils/customFunction";

interface Transferee {
  folio_no?: string;
  unitholder_name?: string;
  transferees_unit_transfer?: string | number;
  name?: string;
}

interface TransactionTransferTableProps {
  reportTxn: any[];
  itemsToShow: number;
}

export const TransactionTransferTable: React.FC<
  TransactionTransferTableProps
> = ({ reportTxn, itemsToShow }) => {
  const parseTransfrees = (transfreesStr: string): Transferee[] => {
    try {
      if (!transfreesStr) return [];
      return typeof transfreesStr === "string"
        ? JSON.parse(transfreesStr)
        : transfreesStr;
    } catch (e) {
      return [];
    }
  };

  return (
    <div style={{ overflowX: "auto", overflowY: "hidden" }}>
      <table className="report" style={{ color: "black", width: "100%" }}>
        <thead>
          <tr>
            <th>
              <span className="htmltoPdfStyle" id="test">
                Transaction Date
              </span>
            </th>
            <th>
              <span className="htmltoPdfStyle" id="test">
                Fund Code
              </span>
            </th>
            <th>
              <span className="htmltoPdfStyle" id="test">
                Folio No
              </span>
            </th>
            <th>
              <span className="htmltoPdfStyle text-center" id="test">
                Name
              </span>
            </th>
            <th>
              <span className="htmltoPdfStyle" id="test">
                Remain Holding
              </span>
            </th>
            <th>
              <span className="htmltoPdfStyle" id="test">
                Transfrees Folio No
              </span>
            </th>
            <th>
              <span className="htmltoPdfStyle" id="test">
                Transfrees Name
              </span>
            </th>
            <th>
              <span className="htmltoPdfStyle" id="test">
                Transfer Of Units
              </span>
            </th>
          </tr>
        </thead>
        <tbody className="report-table-body">
          {reportTxn
            .slice(0, itemsToShow)
            .map((transaction: any, index: number) => {
              const transfrees: Transferee[] = parseTransfrees(
                transaction.transfrees,
              );
              const settlementDate =
                transaction.settlement_date?.$date ||
                transaction.settlement_date;

              return (
                <tr key={transaction.txn_id || index}>
                  <td className="htmltoPdfStyle" id="test">
                    {settlementDate
                      ? moment(settlementDate).format("YYYY-MM-DD")
                      : ""}
                  </td>
                  <td className="htmltoPdfStyle" id="test">
                    {transaction.fund_code || ""}
                  </td>
                  <td className="htmltoPdfStyle" id="test">
                    {transaction.folio_no || ""}
                  </td>
                  <td className="htmltoPdfStyle" id="test">
                    {transaction.unitholder_name || ""}
                  </td>
                  <td className="htmltoPdfStyle text-right" id="test">
                    {numberWithCommas(
                      typeof transaction.remain_holding === "number"
                        ? transaction.remain_holding.toFixed(4)
                        : transaction.remain_holding || "0",
                    )}
                  </td>

                  {/* Stacked Transferees Folio Numbers */}
                  <td className="htmltoPdfStyle text-center" id="test">
                    {transfrees.map((t, i) => (
                      <div key={i} style={{ whiteSpace: "nowrap" }}>
                        {t.folio_no || "-"}
                      </div>
                    ))}
                  </td>

                  {/* Stacked Transferees Names */}
                  <td className="htmltoPdfStyle" id="test">
                    {transfrees.map((t, i) => (
                      <div key={i} style={{ whiteSpace: "nowrap" }}>
                        {t.unitholder_name || t.name || "-"}
                      </div>
                    ))}
                  </td>

                  {/* Stacked Transferees Units Transferred */}
                  <td className="htmltoPdfStyle text-right" id="test">
                    {transfrees.map((t, i) => (
                      <div key={i} style={{ whiteSpace: "nowrap" }}>
                        {numberWithCommas(
                          parseFloat(
                            (t.transferees_unit_transfer as string) || "0",
                          ).toFixed(0),
                        )}
                      </div>
                    ))}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default TransactionTransferTable;
